import { module } from 'stereomodularjs';
import Plyr from 'plyr';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let url = this.el.dataset.url;
        let type = this.el.dataset.vimeo ? 'vimeo' : 'youtube';
        let videoEl = this.el.querySelector('.c-video').querySelector('video');
        let videoImage = this.el.querySelector('.c-video__img');
        this.el.querySelector('.c-video__button').addEventListener('click', () => {
            videoImage.style.display = 'none';
            this.initVideo(videoEl, url, type);
        });
    }

    initVideo(el, url, type) {
        let player = new Plyr(el, {
            controls: ['play', 'progress', 'current-time', 'mute', 'volume'],
            youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
            vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false },
            autoplay: true,
        });
        player.source = {
            type: 'video',
            sources: [
                {
                    src: url,
                    provider: type,
                },
            ],
        };
    }
}
